import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FitnessCenterIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FitnessCenterIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.9445 4.04272C21.7296 3.80064 21.3593 3.7786 21.1171 3.99353L17.954 6.80157C17.6133 7.10406 17.2424 7.24491 16.7868 7.24491H10.957C10.6334 7.24491 10.3709 7.50731 10.3709 7.83098C10.3709 8.15465 10.6333 8.41705 10.957 8.41705H16.7868C16.945 8.41705 17.0992 8.40494 17.2495 8.38216L15.7874 15.6979C15.2029 15.7611 14.6836 16.045 14.3061 16.5132L13.9978 16.8955H4.90112C3.34992 16.8955 2.08789 18.1575 2.08789 19.7087V19.8258C2.08789 20.1495 2.35029 20.4119 2.67396 20.4119H3.57252V20.5682C3.57252 20.8918 3.83492 21.1542 4.15859 21.1542C4.48226 21.1542 4.74466 20.8918 4.74466 20.5682V20.4119H18.1461V20.5682C18.1461 20.8918 18.4085 21.1542 18.7322 21.1542C19.0558 21.1542 19.3182 20.8918 19.3182 20.5682V20.4119H20.2168C20.5405 20.4119 20.8029 20.1495 20.8029 19.8258V17.1691C20.8029 16.3539 20.1424 15.6902 19.3285 15.6846L21.38 5.32757L21.8953 4.87009C22.1374 4.6552 22.1594 4.28477 21.9445 4.04272ZM19.6307 17.1691V19.2397H3.32827C3.5305 18.5626 4.15908 18.0676 4.90111 18.0676H14.2781C14.4552 18.0676 14.623 17.9874 14.7342 17.8495L15.2185 17.2491C15.4286 16.9886 15.7049 16.8565 16.0396 16.8565H19.3181C19.4904 16.8565 19.6307 16.9967 19.6307 17.1691ZM18.1336 15.6842H16.9855L18.5568 7.82221C18.6162 7.77658 18.6749 7.72895 18.7322 7.67808L19.9302 6.6146L18.1336 15.6842Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FitnessCenterIcon;
